import React from 'react';
import SearchComponent from './search/index';
import SEO from '../components/seo';

const Search = () => {
  return (
    <>
      <SEO
        title="Search"
        description="Search for products and stores"
      />
      <SearchComponent />
    </>
  );
};

export default Search;